import { render, staticRenderFns } from "./provision-rate-card.vue?vue&type=template&id=5e2405cb&scoped=true&"
import script from "./provision-rate-card.vue?vue&type=script&lang=js&"
export * from "./provision-rate-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2405cb",
  null
  
)

export default component.exports